import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/icons/system/system-information-fill/system-information-fill.component.js'

const tagName = 'dap-ds-icon-information-fill'

/**
 * `dap-ds-icon-information-fill`
 * @summary An icon
 * @element dap-ds-icon-information-fill
 * @title - SystemInformationFill
 * @group icon
 * @icontype system
 *
 * @attribute {number} size - (optional) The width and height in pixels
 * @attribute {boolean} selected - (optional) Sets the icon color via the `fill` attribute
 * @attribute {string} accessibilityTitle - (optional) When using the icon standalone, make it meaningful for accessibility
 * @attribute {boolean} focusable - (optional) If `true` the icon can receive focus
 *
 * @csspart base - The main icon container.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'SystemInformationFill',
})

export default reactWrapper
